<template>
    <div class="app-container">
        <data-table style="width: 100%; height: 584.6px; overflow-y: scroll" :module-info="moduleInfo" :tb-columns="tbColumns" :toolbar-btns="listpageBtns" :on-list-data-before-load="onListDataBeforeLoad" :on-list-data-loaded="onListDataLoaded" :on-delete-successed="onDeleteSuccessed" :on-cell-click="onCellClick" />
        <Basicform v-if="formType === 'mainform'" key="main" :title="formTitle" :win-width="mainModuleInfo.winWidth" :win-height="mainModuleInfo.winHeight" :toolbar-btns="busiformBtns" :on-basic-form-before-open="onMainBasicFormBeforeOpen" :on-basic-form-opened="onMainBasicFormOpened" :on-basic-form-before-submit="onMainBasicFormBeforeSubmit" :on-basic-form-submited="onMainBasicFormSubmited">
            <template #default="slotProps" style="width: 100%; height: 584.6px; overflow-y: scroll">
                <busi-form key="main" :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="mainModuleInfo" />
            </template>
        </Basicform>

        <Basicform v-if="formType === 'subform'" key="sub" :title="formTitle" :win-width="subModuleInfo.winWidth" :win-height="subModuleInfo.winHeight" :toolbar-btns="subBusiformBtns" :on-basic-form-before-open="onSubBasicFormBeforeOpen" :on-basic-form-opened="onSubBasicFormOpened" :on-basic-form-before-submit="onSubBasicFormBeforeSubmit" :on-basic-form-submited="onSubBasicFormSubmited">
            <template #default="slotProps" style="width: 100%; height: 584.6px; overflow-y: scroll">
                <busi-form :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="subModuleInfo" />
            </template>
        </Basicform>

        <Basicform :title="formTitle" :module-code="moduleInfo.moduleCode" :win-width="moduleInfo.winWidth" :win-height="moduleInfo.winHeight" :toolbar-btns="busiformBtns" :on-basic-form-before-open="onBasicFormBeforeOpen" :on-basic-form-opened="onBasicFormOpened" :on-basic-form-before-submit="onBasicFormBeforeSubmit" :on-basic-form-submited="onBasicFormSubmited">
            <template #default="slotProps" style="width: 100%; height: 584.6px; overflow-y: scroll">
                <busi-form :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfo" />
            </template>
        </Basicform>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            loginUser: {},
            moduleInfo: { formTemplate: 'dcontent/busiformurl?vwtype=W&url=/clgl/clxx/form2.html', winWidth: 1000, delUrl: 'clgl/clxx/delete', addNewUrl: 'clgl/clxx/addNew', insertUrl: 'clgl/clxx/insert', moduleCode: 'clglClxx', winHeight: 600, updateUrl: 'clgl/clxx/update', listDataUrl: 'clgl/clxx/listdata', getByIdUrl: 'clgl/clxx/getById' },
            tbColumns: [
                { field: 'state', checkbox: true, width: '45px', sortable: false, align: 'center' },
                { listAdvSearchElement: '', field: 'index', width: '45px', sortable: false, propType: '', align: 'center', title: this.$tx('fields.index', '序号'), searchable: false },
                { listAdvSearchElement: 'input', field: 'carNumber', width: '150px', sortable: true, propType: 'String', align: 'center', title: this.$tx('clgl.clxx.fields.carNumber', '车牌号'), searchable: true },
                { listAdvSearchElement: 'select', field: 'carType', width: '150px', elementFormatter: this.$tx('clgl.clxx.carTypeFormat', '1：大型车\r\n2：中型车\r\n3：小型车\r\n4：微型车\r\n'), sortable: true, propType: 'String', align: 'center', title: this.$tx('clgl.clxx.fields.carType', '车辆类型'), searchable: true },
                { listAdvSearchElement: 'input', field: 'carModel', width: '150px', sortable: true, propType: 'String', align: 'left', title: this.$tx('clgl.clxx.fields.carModel', '品牌型号'), searchable: true },
                { listAdvSearchElement: 'input', field: 'drivingLicense', width: '', sortable: true, propType: 'String', align: 'left', title: this.$tx('clgl.clxx.fields.drivingLicense', '行驶证'), searchable: true },
                { listAdvSearchElement: 'input', field: 'totalPassenger', width: '100px', sortable: true, propType: 'Integer', align: 'center', title: this.$tx('clgl.clxx.fields.totalPassenger', '载客数'), searchable: true },
                { listAdvSearchElement: 'date', field: 'carRegistTime', width: '200px', elementFormatter: 'format：yyyy-MM-dd HH:mm\r\n', sortable: true, propType: 'java.util.Date', align: 'center', title: this.$tx('clgl.clxx.fields.carRegistTime', '年审有效期至'), searchable: true }
            ],
            listpageBtns: [
                { btnName: this.$tx('pageBtns.add', '新增'), btnIcon: 'plus', btnClick: 'addObject();', btnPermission: 'addObject', id: 'btn_add', btnType: 'toolbar' },
                { btnName: this.$tx('pageBtns.del', '删除'), btnIcon: 'close', btnClick: 'deleteIds();', btnPermission: 'deleteIds', id: 'btn_deleteIds', btnType: 'toolbar' },
                { btnName: this.$tx('pageBtns.edit', '编辑'), btnIcon: 'edit', btnClick: 'editObject(row.id);', btnPermission: 'editObject', id: 'btn_edit', btnType: 'column' },
                { btnName: this.$tx('pageBtns.del', '删除'), btnIcon: 'delete', btnClick: 'deleteIds(row.id);', btnPermission: 'deleteIds', id: 'btn_deleteId', btnType: 'column' }
            ],
            formTitle: this.$tx('clgl.clxx.clInfo', '车辆信息'),
            formType: '',
            row: {},
            mainModuleInfo: {
                formTemplate: 'dcontent/busiformurl?vwtype=W&url=/clgl/clxx/form.html',
                winWidth: 1000,
                delUrl: 'clgl/clxx/delete',
                addNewUrl: 'clgl/clxx/addNew',
                insertUrl: 'clgl/clxx/insert',
                moduleCode: 'clglClxx',
                winHeight: 600,
                updateUrl: 'clgl/clxx/update',
                listDataUrl: 'clgl/clxx/listdata',
                getByIdUrl: 'clgl/clxx/getById'
            },
            subModuleInfo: {
                formTemplate: 'dcontent/busiformurl?vwtype=W&url=/clgl/clxx/form2.html',
                winWidth: 1000,
                delUrl: 'clgl/clxx/delete',
                addNewUrl: 'clgl/clxx/addNew',
                insertUrl: 'clgl/clxx/insert',
                moduleCode: 'clglClxx',
                winHeight: 600,
                updateUrl: 'clgl/clxx/update',
                listDataUrl: 'clgl/clxx/listdata',
                getByIdUrl: 'clgl/clxx/getById'
            },
            busiformBtns: [
                {
                    id: 'btn_edit',
                    btnName: '修 改',
                    btnIcon: 'edit',
                    btnClick: this.editBusiform,
                    btnPermission: 'editObject',
                    btnStyleType: 'default'
                },
                {
                    id: 'btn_close',
                    btnName: '关 闭',
                    btnIcon: 'close',
                    btnClick: 'closeDialog',
                    btnPermission: '',
                    btnStyleType: 'default'
                }
            ]
        }
    },
    computed: {},
    watch: {},
    created: function () {
        // 列表页面配置ID
        this.moduleInfo.listpageViewUrl = '[ecyoa]-/clgl/clxx/list.html'
        const _this = this
        this.listpageBtns.forEach(function (btn) {
            btn.btnParams = null
            if (typeof btn.btnClick === 'string') {
                let btnClick = btn.btnClick
                if (btn.btnClick.indexOf('(') !== -1) {
                    let btnParams = btnClick.substring(btnClick.indexOf('(') + 1, btnClick.lastIndexOf(')'))
                    if (btnParams !== '') {
                        btnParams = btnParams.replace(/'/g, '').split(',')
                        btn.btnParams = btnParams
                    }
                    btnClick = btnClick.split('(')[0]
                }
                if (_this[btnClick]) {
                    btn.btnClick = _this[btnClick]
                }
            }
        })

        // 操作列定义
        this.tbColumns[this.tbColumns.length] = {
            field: 'column_operate',
            title: this.$tx('pageBtns.operate', '操作'),
            width: '70px',
            align: 'center',
            valign: 'middle'
        }

        this.moduleInfo = this.subModuleInfo

        let formurl = this.moduleInfo.formTemplate.split('url=')[1]
        formurl = formurl.replace(/\//g, '.')
        formurl = '#/dcontent/vuebusiform/W/' + formurl.substring(1).replace('.html', '.vue')
        formurl += '?sysCode=' + (this.$route.meta.sysCode || '')
        this.$options.components['BusiForm'] = this.$loadComponent(formurl)
    },
    beforeDestroy: function () {
        this.$bus.off('openSubForm')
    },
    mounted: function () {},
    methods: {
        /**
         * 加载数据准备，qparams为查询参数对象，不需要返回值
         */
        onListDataBeforeLoad: function ($scope, qparams) {
            this.loginUser = $scope.loginUser

            console.log('clglClxx listdata before load..')
        },
        /**
         * 加载数据完成，pageInfo为包含查询结果的分页信息对象，不需要返回值
         */
        onListDataLoaded: function ($scope, pageInfo) {
            console.log('clglClxx listdata loaded')
        },
        /**
         * 数据删除成功，ids为已删除成功的clglClxx对象ID数组，即将刷新列表，不需要返回值
         */
        onDeleteSuccessed: function ($scope, ids) {
            console.log('clglClxx delete successed')
        },
        /**
         * 表单打开检查，vo为已加载clglClxx对象，允许打开：defer.resolve(true)，阻止打开：defer.reject(reason)
         */
        onBasicFormBeforeOpen: function ($scope, vo, defer) {
            if (process.env.NODE_ENV === 'development') console.log('clglClxx form before open')
            defer.resolve(true)
        },
        /**
         * 表单打开完成，vo为已加载的clglClxx对象，前端页面dom对象已完成初始化、已经呈现，不需要返回值
         */
        onBasicFormOpened: function ($scope, vo) {
            if (process.env.NODE_ENV === 'development') console.log('clglClxx form opened')
        },
        /**
         * 表单提交事件，可执行业务数据高级校验，vo为待提交的clglClxx对象，校验成功：defer.resolve(true)，校验失败：defer.reject(reason)
         */
        onBasicFormBeforeSubmit: function ($scope, vo, defer) {
            /* this.$confirm('您是否确认提交保存?', '确认操作', {
confirmButtonText: '确定',
cancelButtonText: '取消',
type: 'warning'
})
.then(() => {
    defer.resolve(true)
})
.catch(err => {
    defer.reject(err)
})*/

            if (process.env.NODE_ENV === 'development') console.log('clglClxx form submit validation success')
            defer.resolve(true)
        },
        /**
         * 表单提交完成，vo为已保存成功的clglClxx对象，窗口即将关闭，不需要返回值
         */
        onBasicFormSubmited: function ($scope, vo) {
            if (process.env.NODE_ENV === 'development') console.log('clglClxx form submited')
        },

        onCellClick: function (v) {
            this.moduleInfo = this.mainModuleInfo
            this.$forceUpdate()
            // console.log('执行了xxxxxx')
            const _this = this
            this.row = v
            this.formType = 'mainform'
            console.log('this.moduleInfo', this.moduleInfo)
            this.$nextTick(function () {
                _this.$bus.emit('openBusiform', _this.mainModuleInfo, v, 0)
            })
        },
        onMainBasicFormOpened: function () {
            this.moduleInfo = this.subModuleInfo
        },
        editBusiform: function () {
            this.editSubForm(this.row)
        },
        editSubForm: function (v) {
            this.formType = 'subform'
            const that = this
            this.moduleInfo = this.subModuleInfo
            this.$nextTick(function () {
                that.$bus.emit('openBusiform', that.subModuleInfo, v, 1)
            })
        },
        onMainBasicFormBeforeOpen: function () {
            console.log('this.moduleInfo', this.moduleInfo)
        },
        onMainBasicFormBeforeSubmit: function () {},
        onMainBasicFormSubmited() {}
    }
}
</script>

<style scoped>
</style>
<style>
</style>
